"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isCartNotFoundError = function isCartNotFoundError(error) {
  var _error$response, _error$data, _error$data2;
  var status = (error === null || error === void 0 ? void 0 : error.status) || (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || (error === null || error === void 0 || (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.status);
  var message = (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 || (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.message) || '';
  return status === 404 || /cart.*not found/i.test(message);
};
var _default = exports["default"] = isCartNotFoundError;